<template lang="html">
  <v-row no-gutters class="px-sm-12 mx-sm-12 py-2 my-2">
    <v-col v-for="(item, i) in content" :key="i"
      data-aos="fade-up"
      :data-aos-delay="getDelay(i)"
      cols="12"
      class="col-sm-6 col-md-3"
    >
      <v-card flat>
        <v-card-title class="justify-center">
          <v-icon :color="item.iconColor" :class="[{'text-h1': !$vuetify.breakpoint.mobile, 'text-h2': $vuetify.breakpoint.mobile}]">{{item.icon}}</v-icon>
        </v-card-title>
        <v-card-subtitle class="text-center px-0" :class="[{'text-h4': !$vuetify.breakpoint.mobile, 'text-h5': $vuetify.breakpoint.mobile}]">
          {{item.header}}
        </v-card-subtitle>
        <v-card-text class="">
          <p class="text-center">
            {{item.text}}
          </p>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  const contentAlumnier = [
    {
      icon: 'mdi-account-check',
      iconColor: 'success',
      header: 'Segment your audience',
      text: `Reach the correct audience you are targeting to.
      Most of your alumni are not updated in your database.
      Leverage on Alumnier to reduce your outbound messages.`
    },
    {
      icon: 'mdi-av-timer',
      iconColor: 'primary',
      header: 'Save time and money',
      text: `Be smart and do not lose time doing a recurrent task.
      Let Alumnier to update your records periodically and use wisely your resources.`
    },
    {
      icon: 'mdi-code-json',
      iconColor: 'primary',
      header: 'Integrate with your CRM',
      text: `Alumnier is very flexible.
      You can export your results either with CSV or JSON and integrate with your CRM tools, like SalesForce`
    },
    {
      icon: 'mdi-filter-variant-plus',
      iconColor: 'primary',
      header: 'Customize your searches',
      text: `Search among multiple fields.
      Compose complex set of filters and search once or save the set of filters for periodic searches`
    },

  ];

  const contentIceverg = [
    {
      icon: 'mdi-clock-check-outline',
      iconColor: 'success',
      header: 'Real-time data',
      text: `Every week all the data is updated and new engagement levels are calculated`
    },
    {
      icon: 'mdi-piggy-bank',
      iconColor: 'primary',
      header: 'Save money',
      text: `Employee turnover cost is around 40% of a year salary,
      use our product to reduce your employee turnover and save money!`
    },
    {
      icon: 'mdi-briefcase-clock-outline',
      iconColor: 'primary',
      header: 'Re-invest your time',
      text: `No won't need more polls or engagement measurements,
      you won't need to stop your team productivity and you will invest all your time to improve your team`
    },
    {
      icon: 'mdi-head-flash-outline',
      iconColor: 'primary',
      header: 'Forecast is the key',
      text: `Older methods (poll-based) are not able to anticipate,
      but our product predicts behaviours and allows you to anticipate hirings and one to one conversations`
    },

  ];


  const delayStep = 150;
  export default {
    data: () => ({
      content: process.env.VUE_APP_PLATFORM === 'Alumnier' ? contentAlumnier : contentIceverg
    }),
    methods: {
      getDelay(i){
        return this.$vuetify.breakpoint.mobile ? 0 : delayStep * i;
      }
    }
  }
</script>

<style lang="css">
</style>
